export default __webpack_public_path__ + "static/TechEvents_logo@2x-e8a6bb52e35cbd0bcb0af4bab800b3a2.png";